import { useRef } from "react";
import classes from "./Popovers.module.css";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { TieredMenu } from "primereact/tieredmenu";
import clsx from "clsx";

const Popover = ({ items = [], isDisabled, children }) => {
  const menu = useRef();
  
  const handleClick = (e) => {
    if (!isDisabled) {
      menu.current.toggle(e);
    }
  };

  return (
    <>
      <span
        onClick={handleClick}
        className={clsx({
          [classes.disabled]: isDisabled
        })}
      >
        {children ? children : (
          <PiDotsThreeVerticalBold
            className={clsx(classes.actionsDot, {
              [classes.disabledIcon]: isDisabled
            })}
            size={24}
            color="var(--icon-color)"
          />
        )}
      </span>
      <TieredMenu model={items} popup ref={menu} breakpoint="767px" />
    </>
  );
};

export default Popover;
